import {ColorSchemeType} from 'platform/components';
import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

export function getColorStripePathByScheme(
  colorScheme: ColorSchemeType,
  isHover: boolean = false
): ThemeColorPath {
  return match<ColorSchemeType, ThemeColorPath>(colorScheme)
    .with('black', () => (isHover ? 'general.black' : 'palettes.neutral.900.100'))
    .with('neutral', () => (isHover ? 'palettes.neutral.500.100' : 'palettes.neutral.300.100'))
    .with('blue', () => 'palettes.blue.70.100')
    .with('teal', () => (isHover ? 'palettes.teal.70.100' : 'palettes.teal.60.100'))
    .with('green', () => (isHover ? 'palettes.green.70.100' : 'palettes.green.60.100'))
    .with('orange', () => (isHover ? 'palettes.orange.70.100' : 'palettes.orange.60.100'))
    .with('yellow', () => (isHover ? 'palettes.yellow.70.100' : 'palettes.yellow.60.100'))
    .with('magenta', () => (isHover ? 'palettes.magenta.70.100' : 'palettes.magenta.60.100'))
    .with('purple', () => (isHover ? 'palettes.purple.70.100' : 'palettes.purple.60.100'))
    .with('red', () => (isHover ? 'palettes.red.70.100' : 'palettes.red.60.100'))
    .exhaustive();
}
